export default __webpack_public_path__ + "static/media/uploader-abbottNeo-2.93732d33.png";